// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition48: FC<Recognition48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M36.9 18.884c0-7.125-5.776-12.9-12.9-12.9-7.125 0-12.9 5.775-12.9 12.9 0 7.124 5.775 12.899 12.9 12.9 7.124 0 12.9-5.776 12.9-12.9ZM11.287 35.72l4.69.643 2.901 3.74 3.144-5.444a15.826 15.826 0 0 1-8.11-3.487l-2.626 4.548Zm22.8-4.548a15.826 15.826 0 0 1-8.11 3.487l3.143 5.444 2.903-3.74 4.69-.643-2.627-4.548ZM31.874 15.59 21.836 25.629l-6.131-6.131 2.12-2.121 4.01 4.01 7.918-7.918 2.122 2.12Zm8.025 3.294c0 3.833-1.357 7.349-3.616 10.095l5.258 9.108-7.9 1.083-4.888 6.3L24 37.235l-4.753 8.235-4.89-6.3-7.899-1.083 5.258-9.109A15.835 15.835 0 0 1 8.1 18.885c0-8.781 7.118-15.9 15.9-15.9 8.78 0 15.9 7.118 15.9 15.9Z" />
        </svg>
    );
};

export default Recognition48;
